// extracted by mini-css-extract-plugin
export default {"marginBottom":"styles_marginBottom__FeRwJ","tabs":"styles_tabs__K2Tex","selectedTab":"styles_selectedTab__bIXMx"};